module.exports = __webpack_public_path__ + "static/media/left-arrow-from-left.764b929a.svg";